import './css/MemberMallOrderList.css'

import { useEffect, useState } from "react"
import { useParams } from 'react-router-dom'
import { Table, Button, Modal } from 'antd'
import { baseAxiosNoInfo } from "../../tool/axios"

const { Column } = Table

type pagination = {
    page_num: number,
    page_size: number,
    total: number
}

export default function () {

    const { id }: { id: string } = useParams()

    const [tableData, setTableData] = useState<any>([])
    const [orderDetailItem, setOrderDetailItem] = useState<any>([])
    const [orderDetailTableData, setOrderDetailTableData] = useState<any>([])

    const [visible, setVisible] = useState(false)

    const [pagination, setPagination] = useState<pagination>({
        page_num: 1,
        page_size: 8,
        total: 0
    })

    useEffect(() => {
        getTableData()
    }, [id])

    const getTableData = () => {
        const iPagination: any = { ...pagination }
        iPagination.page = iPagination.page_num
        iPagination.size = iPagination.page_size

        delete iPagination.page
        delete iPagination.size
        delete iPagination.total

        baseAxiosNoInfo.get('/member_center/member/mall_order_page_list', {
            params: {
                ...iPagination,
                member_id: id
            }

        }).then((res: any) => {
            if (res) {
                const { records, total } = res

                setPagination({
                    ...pagination,
                    total
                })
                setTableData(records)
            }
        })
    }

    // 查询订单详情
    const getOrderDetail = (member_id: any, orderItem: any) => {
        baseAxiosNoInfo.get('/member_center/member/mall_order_page_list/shopping_cart_detail', {
            params: {
                member_id: member_id,
                order_id: orderItem.order_id
            }

        }).then((res: any) => {
            if (res) {
                // 设置弹窗顶部表格信息
                setOrderDetailItem(orderItem)
                // 设置具体订单详情信息
                setOrderDetailTableData(res)
            }

        }).catch((err) => {
            setVisible(false)
        })

        setVisible(true)
    }

    return (
        <div className="common-page">
            <div className="common-main">
                <Table dataSource={tableData} scroll={{ x: 'max-content' }} bordered={true} rowKey="id" pagination={pagination}>
                    <Column title="订单编号" dataIndex="order_code" key="order_code" />
                    <Column title="订单状态" dataIndex="status" key="status"
                        render={(v: any) => {
                            switch (v) {
                                case 1:
                                    return '待付款'
                                case 2:
                                    return '待发货'
                                case 3:
                                    return '已发货'
                                case 4:
                                    return '已收货'
                                default:
                                    return '已取消'
                            }
                        }}
                    />
                    <Column title="是否购物车订单" dataIndex="is_shopping_cart" key="is_shopping_cart"
                        render={(v: any) => {
                            switch (v) {
                                case 0:
                                    return '否'
                                default:
                                    return '是'
                            }
                        }}
                    />
                    <Column title="供应商名称" dataIndex="supply_name" key="supply_name"
                        render={(v: any, dd: any) => {
                            return dd.is_shopping_cart === 1 ? '' : dd.supply_name
                        }}
                    />
                    <Column title="商品名称" dataIndex="goods_name" key="goods_name"
                        render={(v: any, dd: any) => {
                            if (dd.is_shopping_cart == 1) {
                                return (
                                    <Button size="small" onClick={() => { getOrderDetail(id, dd) }}>查看详情</Button>
                                )
                            }

                            return dd.goods_name
                        }}
                    />
                    <Column title="商品售价" dataIndex="sale_price" key="sale_price"
                        render={(v: any, dd: any) => {
                            return dd.is_shopping_cart === 1 ? '' : dd.sale_price
                        }}
                    />
                    <Column title="商品数量" dataIndex="num" key="num"
                        render={(v: any, dd: any) => {
                            return dd.is_shopping_cart === 1 ? '' : dd.num
                        }}
                    />
                    <Column title="订单总金额" dataIndex="total_amount" key="total_amount" />
                    <Column title="优惠金额" dataIndex="deduct_amount" key="deduct_amount" />
                    <Column title="实付金额" dataIndex="final_pay_amount" key="final_pay_amount" />
                    <Column title="收货人" dataIndex="delivery_name" key="delivery_name" />
                    <Column title="收货手机号" dataIndex="delivery_phone" key="delivery_phone" />
                    <Column title="收货地址" dataIndex="delivery_address" key="delivery_address" />
                    <Column title="下单时间" dataIndex="order_time" key="order_time" />
                </Table>
            </div>

            {/* 查看详情 */}
            <Modal width={1000} className="order-modal" title="订单详情" visible={visible} maskClosable={false} cancelText={'关闭'} onCancel={() => { setVisible(false) }} >
                {/* 订单信息 */}
                <Table dataSource={[orderDetailItem]} scroll={{ x: 'max-content' }} rowKey="id" pagination={false}>
                    <Column title="订单状态" dataIndex="status" key="status" render={(v: any) => {
                        switch (v) {
                            case 1:
                                return '待付款'
                            case 2:
                                return '待发货'
                            case 3:
                                return '已发货'
                            case 4:
                                return '已收货'
                            case 5:
                                return '已取消'
                        }
                    }} />
                    <Column title="商品数量" dataIndex="num" key="num" />
                    <Column title="订单总金额" dataIndex="total_amount" key="total_amount" />
                    <Column title="优惠金额" dataIndex="deduct_amount" key="deduct_amount" />
                    <Column title="实付金额" dataIndex="final_pay_amount" key="final_pay_amount" />
                </Table>

                {/* 订单详情信息 */}
                <Table style={{ marginTop: 18 }} dataSource={orderDetailTableData} scroll={{ x: 'max-content' }} rowKey="id" pagination={false}>
                    <Column title="供应商名称" dataIndex="supply_name" key="supply_name" />
                    <Column title="商品名称" dataIndex="goods_name" key="goods_name" />
                    <Column title="商品单价" dataIndex="sale_price" key="sale_price" />
                    <Column title="商品数量" dataIndex="num" key="num" />
                </Table>
            </Modal>
        </div>
    )
}